import { put, call, take, fork } from 'redux-saga/effects'
import { editSectionOrderService } from 'src/api/course'
import { EDIT_SECTION_ORDER } from 'src/reducers/course/type'
import { editSectionOrderSuccess } from 'src/reducers/course/action'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* editSectionOrderFlow(payload) {
  try {
    const { id, sections, callback } = payload

    const response = yield call(editSectionOrderService, id, sections)

    yield put(operationSuccess())
    yield put(editSectionOrderSuccess(sections))

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* editSectionOrderWatcher() {
  while (true) {
    const action = yield take(EDIT_SECTION_ORDER)
    const { payload } = action

    yield fork(generalSaga, editSectionOrderFlow, payload, false)
  }
}
